import { useState } from 'react';
import { toast } from 'react-toastify';
import { FaPencilAlt } from 'react-icons/fa';
import { CreditAnalysis } from '../types';

interface Props {
    row: CreditAnalysis;
    onSave: (uuid: string, status: string) => Promise<void>;
}

const DECISION_OPTIONS = [
    { value: 'PENDING', label: 'Pendente' },
    { value: 'APPROVED', label: 'Aprovado' },
    { value: 'REJECTED', label: 'Reprovado' },
    { value: 'PRE_APPROVED', label: 'Pré-aprovado' },
    { value: 'CANCELED', label: 'Cancelado' },
];

export default function EditableDecision({ row, onSave }: Props) {
    const [editing, setEditing] = useState(false);
    const s = (row.status || 'PENDING').toUpperCase();
    const current = DECISION_OPTIONS.find(o => o.value === s) || DECISION_OPTIONS[0];
    const cls = s === 'APPROVED' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
        : s === 'REJECTED' ? 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
            : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200';

    if (editing) {
        return (
            <select
                autoFocus
                defaultValue={s}
                onChange={async (e) => {
                    setEditing(false);
                    if (e.target.value !== s) {
                        try { await onSave(row.uuid, e.target.value); } catch { toast.error('Erro ao salvar'); }
                    }
                }}
                onBlur={() => setEditing(false)}
                className="w-full px-1 py-0.5 text-xs border border-blue-400 rounded bg-white dark:bg-slate-700 dark:text-gray-100 focus:outline-none appearance-none"
            >
                {DECISION_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
        );
    }
    return (
        <span onClick={() => setEditing(true)} className={`flex items-center justify-center gap-1 px-2 py-1 rounded text-xs font-medium cursor-pointer ${cls}`} title="Clique para alterar">
            {current.label}
            <FaPencilAlt className="text-[8px] opacity-50" />
        </span>
    );
}
